import * as __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__ from "./http-client.mjs";
class SstServices extends __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.HttpClient {
    getAllMediaSstServicesV1MediaUserIdGet = (userId, params = {})=>this.request({
            path: `/sst-services/v1/media/${userId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    uploadMediaSstServicesV1MediaUserIdPost = (userId, data, params = {})=>this.request({
            path: `/sst-services/v1/media/${userId}`,
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.FormData,
            format: 'json',
            ...params
        });
    updateIsprimaryFlagSstServicesV1MediaUserIdMediaIdPut = (mediaId, userId, data, params = {})=>this.request({
            path: `/sst-services/v1/media/${userId}/${mediaId}`,
            method: 'PUT',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            format: 'json',
            ...params
        });
    deleteMediaSstServicesV1MediaUserIdMediaIdDelete = (userId, mediaId, params = {})=>this.request({
            path: `/sst-services/v1/media/${userId}/${mediaId}`,
            method: 'DELETE',
            secure: true,
            ...params
        });
    getBreedsSstServicesV1PetsBreedsGet = (params = {})=>this.request({
            path: "/sst-services/v1/pets/breeds",
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    getBreedSstServicesV1PetsBreedsBreedIdGet = (breedId, params = {})=>this.request({
            path: `/sst-services/v1/pets/breeds/${breedId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    getPetownershipplansSstServicesV1PetsPetownershipplansGet = (params = {})=>this.request({
            path: "/sst-services/v1/pets/petownershipplans",
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    getPetTypesSstServicesV1PetsPettypesGet = (params = {})=>this.request({
            path: "/sst-services/v1/pets/pettypes",
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    getPetTypeSstServicesV1PetsPettypesPetTypeIdGet = (petTypeId, params = {})=>this.request({
            path: `/sst-services/v1/pets/pettypes/${petTypeId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    getUserAllPetsSstServicesV1PetsUsersUserIdPetsGet = (userId, params = {})=>this.request({
            path: `/sst-services/v1/pets/users/${userId}/pets`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    postUserPetsSstServicesV1PetsUsersUserIdPetsPost = (userId, data, params = {})=>this.request({
            path: `/sst-services/v1/pets/users/${userId}/pets`,
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            format: 'json',
            ...params
        });
    getUserPetSstServicesV1PetsUsersUserIdPetsPetIdGet = (userId, petId, params = {})=>this.request({
            path: `/sst-services/v1/pets/users/${userId}/pets/${petId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    updateUserPetSstServicesV1PetsUsersUserIdPetsPetIdPut = (userId, petId, data, params = {})=>this.request({
            path: `/sst-services/v1/pets/users/${userId}/pets/${petId}`,
            method: 'PUT',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            format: 'json',
            ...params
        });
    deleteUserPetSstServicesV1PetsUsersUserIdPetsPetIdDelete = (userId, petId, params = {})=>this.request({
            path: `/sst-services/v1/pets/users/${userId}/pets/${petId}`,
            method: 'DELETE',
            secure: true,
            format: 'json',
            ...params
        });
    getUserSubscriptionsSstServicesV1SubscriptionsUserIdGet = (userId, params = {})=>this.request({
            path: `/sst-services/v1/subscriptions/${userId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    listAvailableSubscriptionsSstServicesV1SubscriptionsUserIdAvailableSubscriptionsGet = (userId, params = {})=>this.request({
            path: `/sst-services/v1/subscriptions/${userId}/available_subscriptions`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    createUserPostEndpointSstServicesV1SubscriptionsUserIdSubscriptionsPost = (userId, data, params = {})=>this.request({
            path: `/sst-services/v1/subscriptions/${userId}/subscriptions`,
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            format: 'json',
            ...params
        });
    getUserByEmailSstServicesV1UsersGet = (query, params = {})=>this.request({
            path: "/sst-services/v1/users/",
            method: 'GET',
            query: query,
            secure: true,
            format: 'json',
            ...params
        });
    getUserByUserIdSstServicesV1UsersUserIdGet = (userId, params = {})=>this.request({
            path: `/sst-services/v1/users/${userId}`,
            method: 'GET',
            secure: true,
            format: 'json',
            ...params
        });
    updateUserSstServicesV1UsersUserIdPut = (userId, data, params = {})=>this.request({
            path: `/sst-services/v1/users/${userId}`,
            method: 'PUT',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            format: 'json',
            ...params
        });
    updateUserPasswordSstServicesV1UsersUserIdPasswordPost = (userId, data, params = {})=>this.request({
            path: `/sst-services/v1/users/${userId}/password`,
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            ...params
        });
    postCheckUserByEmailSstServicesV1UsersCheckUserEmailPost = (data, params = {})=>this.request({
            path: "/sst-services/v1/users/check-user-email",
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            format: 'json',
            ...params
        });
    disableUserSstServicesV1UsersDisablePost = (data, params = {})=>this.request({
            path: "/sst-services/v1/users/disable",
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            ...params
        });
    deleteUserSstServicesV1UsersDeletePost = (data, params = {})=>this.request({
            path: "/sst-services/v1/users/delete",
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            ...params
        });
    setTempPasswordSstServicesV1UsersSetTempPasswordPost = (data, params = {})=>this.request({
            path: "/sst-services/v1/users/set-temp-password",
            method: 'POST',
            body: data,
            secure: true,
            type: __WEBPACK_EXTERNAL_MODULE__http_client_mjs_e1b39820__.ContentType.Json,
            ...params
        });
}
export { SstServices };
